import { useInfiniteQuery } from 'react-query';
import {
  exploreTradingPhotoCards,
  type ExploreTradingPhotoCardsResponse
} from '../../services/tradingPhotoCardService';

interface UseExploreTradingPhotoCardsParams {
  artistId?: string;
  memberIds?: string | string[];
  eventIds?: string | string[];
  category?: 'exchange' | 'sale';
  userProfileId?: string;
  onlyIdentityVerified?: boolean;
  onlySameCountry?: boolean;
  photoCardCategories?: string | string[];
  sortBy?: 'scoring' | 'recent';
  perPage?: number;
  photoCardId?: string;
}

function toCommaSeparated(value?: string | string[]): string | undefined {
  if (!value || (Array.isArray(value) && value.length === 0)) return undefined;
  return Array.isArray(value) ? value.join(',') : value;
}

export function useExploreTradingPhotoCards({
  artistId,
  memberIds,
  eventIds,
  category,
  userProfileId,
  onlyIdentityVerified,
  onlySameCountry,
  photoCardCategories,
  sortBy = 'scoring',
  perPage = 30,
  photoCardId
}: UseExploreTradingPhotoCardsParams = {}) {
  return useInfiniteQuery<ExploreTradingPhotoCardsResponse, Error>(
    [
      'exploreTradingPhotoCards',
      artistId,
      memberIds,
      eventIds,
      category,
      userProfileId,
      onlyIdentityVerified,
      onlySameCountry,
      photoCardCategories,
      sortBy,
      photoCardId
    ],
    ({ pageParam = 1 }) =>
      exploreTradingPhotoCards({
        artist_id: artistId,
        member_ids: toCommaSeparated(memberIds),
        event_ids: toCommaSeparated(eventIds),
        category,
        user_profile_id: userProfileId,
        identified: onlyIdentityVerified,
        only_same_country: onlySameCountry,
        photo_card_categories: toCommaSeparated(photoCardCategories),
        sort_by: sortBy,
        per_page: perPage,
        photo_card_id: photoCardId,
        page: pageParam
      }),
    {
      getNextPageParam: (lastPage) => {
        const { currentPage, totalPages } = lastPage.meta.pagination;
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
      staleTime: 30 * 1000,
      cacheTime: 5 * 60 * 1000
    }
  );
}
